import { Injectable } from '@angular/core';
import { Inputfiledsbase } from '../../../models/inputfiledsbase';
import { DropdownQuestion } from '../../../question-dropdown';
import { DropdownservicesService } from '../../../../Services/Apis/Dropdownservices/dropdownservices.service';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StudentassignmentsService {
  semisterDropData: any[] = [];

  constructor(private dropdownservice: DropdownservicesService) {}

  loadDropdownData(code: string, dataArray: any[]) {
    let observable: Observable<any>;

    if (code === 'SEMESTERS') {
      observable = this.dropdownservice.getsemisterdrop();
    } else {
      observable = this.dropdownservice.getlookupcodesdropdown(code);
    }

    observable.subscribe((res) => {
      for (let i = 0; i < res.length; i++) {
        let lookupname;
        if (code === 'SEMESTERS') {
          lookupname = res[i]?.name;
        } else {
          lookupname = res[i]?.lookup_name;
        }
        dataArray.push({
          id: res[i].id,
          key: lookupname,
          value: res[i].id,
        });
      }
    });
  }

  getstudentAssignments() {
    this.loadDropdownData('SEMESTERS', this.semisterDropData);

    const questions: Inputfiledsbase<string>[] = [
      new DropdownQuestion({
        key: 'semester_id',
        label: 'Semister',
        required: true,
        options: this.semisterDropData,
        order: 1,
      }),
      new DropdownQuestion({
        key: 'subjects_id',
        label: 'All Subjects',
        required: true,
        options: this.semisterDropData,
        order: 2,
      }),
      new DropdownQuestion({
        key: 'status_id',
        label: 'Status',
        required: true,
        options: this.semisterDropData,
        order: 3,
      }),
    ];

    // Wrap the array into an Observable
    return of(questions.sort((a, b) => a.order - b.order));
  }
}
